import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import AsyncSelect from "react-select/async";
import { signInUser } from "../../Utility/Auth";
// import { setSelcetCustomer } from "../../../features/posSlice";

// import { connect } from "react-redux";
// console.log(this.props.posSaleData);

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";
// const dispatch = useDispatch();

class SelectCustomerLedger extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      selectedOption: {
        label: this.props.SelcetCustomer
          ? this.props.SelcetCustomer.name
          : "WalkWay Customer",
        option: this.props.SelcetCustomer
          ? this.props.SelcetCustomer._id
          : "WalkWay Customer",
      },
      normalSelectOption: null,
    };
  }

  // auth = signInUser();
  // aamarId = this.auth.aamarId;

  fetchData = async (inputValue, callback) => {
    // console.log(this.state);
    let cancelToken;
    // console.log(inputValue);

    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel("Cancel The Previous Request");
    }
    const user = signInUser();
    const { aamarId } = user;

    cancelToken = axios.CancelToken.source();
    const result = await axios.get(
      `${BASE_URL}customer/search/${aamarId}/${inputValue}`,
      {
        cancelToken: cancelToken.token,
      }
    );

    let tempArray = [];

    if (result.data.length > 0) {
      // get match more than one
      result.data.forEach((element) => {
        tempArray.push({
          label: `${element.name} - [ ${element.phone} ]`,
          value: element._id,
        });
      });
    } else {
      tempArray.push({
        label: this.props.posSaleData.customerName,
        option: this.props.posSaleData.customerId,
      });
    }
    callback(tempArray);
    console.log(result.data);
  };

  getValue = async (data) => {
    let cancelToken;

    console.log(data);
    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel("Cancel The Previous Request");
    }

    cancelToken = axios.CancelToken.source();
    const cleanUrl = BASE_URL.endsWith("/")
      ? `${BASE_URL}customer/${data}`
      : `${BASE_URL}/customer/${data}`;
    const result = await axios.get(cleanUrl, {
      cancelToken: cancelToken.token,
    });

    console.log("Due Invoice:", result);

    const customerObj = Array.isArray(result.data) ? result.data[0] : result.data;
    this.props.setSelcetCustomer(customerObj || data);
  };

  onSearchChange = (selectedOption) => {
    if (selectedOption) {
      this.setState({
        selectedOption,
      });
      console.log(selectedOption);
      this.props.setSelcetCustomer(selectedOption.value);
      this.getValue(selectedOption.value);
    }
  };
  // handleChange = (normalSelectOption) => {
  //   this.setState({ normalSelectOption });
  //   console.log(this.state.normalSelectOption);
  // };

  selectRef = React.createRef();

  render() {
    return (
      <AsyncSelect
        value={this.state.selectedOption}
        loadOptions={this.fetchData}
        placeholder="Customer Select"
        key={this.fetchData}
        onChange={(e) => {
          this.onSearchChange(e);
        }}
        defaultOptions={{
          label: "WalkWay Customer",
          option: "",
        }}
        className="basic-single"
        classNamePrefix="select"
        // classNamePrefix="react-select"
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isSearchable={true}
        innerRef={this.selectRef}
        ref={this.props.customerSelect}
      />
    );
  }
}

export default connect(null)(SelectCustomerLedger);
// export default SelectCustomer;
